/** Shared daily spiritual messages — Bhagavad Gita only. Home + Daily Message. */

export const dailyMessages = [
  {
    text: 'You have a right to perform your prescribed duty, but you are not entitled to the fruits of action.',
    textGu: 'તારો અધિકાર માત્ર કર્મ કરવા પર છે, તેના ફળ પર નથી. તેથી કર્મના ફળની આસક્તિ રાખ્યા વિના અને કર્મથી વિમુખ થયા વિના તું તારું કર્તવ્ય બજાવ.',
    author: 'Bhagavad Gita 2.47',
  },

  {
    text: 'The soul is never born and never dies; it is eternal, everlasting, and primeval.',
    textGu: 'આત્માનો ક્યારેય જન્મ થતો નથી અને તેનું ક્યારેય મૃત્યુ થતું નથી. આત્મા શાશ્વત, સનાતન અને અવિનાશી છે.',
    author: 'Bhagavad Gita 2.20',
  },

  {
    text: 'As a person puts on new garments, giving up old ones, the soul similarly accepts new material bodies.',
    textGu: 'જેવી રીતે મનુષ્ય જૂનાં વસ્ત્રો ઉતારીને નવાં વસ્ત્રો ધારણ કરે છે, તેવી જ રીતે આત્મા જૂનું શરીર છોડીને નવું શરીર ધારણ કરે છે.',
    author: 'Bhagavad Gita 2.22',
  },

  {
    text: 'For the soul there is neither birth nor death. It is not slain when the body is slain.',
    textGu: 'આત્માનો ન તો જન્મ થાય છે કે ન તો મૃત્યુ. શરીરનો નાશ થાય ત્યારે પણ આત્માનો નાશ થતો નથી.',
    author: 'Bhagavad Gita 2.19',
  },

  {
    text: 'Perform your duty equipoised, O Arjuna, abandoning all attachment to success or failure. Such equanimity is called yoga.',
    textGu: 'હે અર્જુન, સફળતા કે નિષ્ફળતાની આસક્તિ છોડીને સમભાવથી તારું કર્તવ્ય બજાવ. આ સમત્વભાવને જ યોગ કહેવામાં આવ્યો છે.',
    author: 'Bhagavad Gita 2.48',
  },

  {
    text: 'One who is not disturbed by the incessant flow of desires — that enters like rivers into the ocean — can alone achieve peace.',
    textGu: 'જે વ્યક્તિમાં પ્રવેશતી અસંખ્ય ઇચ્છાઓથી વિચલિત થતો નથી, જેમ નદીઓ સમુદ્રમાં ભળી જાય છતાં સમુદ્ર અચળ રહે છે, તે જ સાચી શાંતિ પ્રાપ્ત કરે છે.',
    author: 'Bhagavad Gita 2.70',
  },

  {
    text: 'From anger, complete delusion arises, and from delusion bewilderment of memory. When memory is bewildered, intelligence is lost.',
    textGu: 'ક્રોધથી મોહ ઉત્પન્ન થાય છે, મોહથી સ્મૃતિભ્રંશ થાય છે, સ્મૃતિભ્રંશથી બુદ્ધિનો નાશ થાય છે અને બુદ્ધિના નાશથી મનુષ્યનું પતન થાય છે.',
    author: 'Bhagavad Gita 2.63',
  },

  {
    text: "Better is one's own dharma, though imperfectly performed, than the dharma of another well performed.",
    textGu: 'બીજાના ધર્મને શ્રેષ્ઠ રીતે આચરવા કરતાં પોતાનો ધર્મ અપૂર્ણ રીતે આચરવો પણ શ્રેયસ્કર છે.',
    author: 'Bhagavad Gita 3.35',
  },

  {
    text: 'The senses are superior to the body; mind is higher than the senses; intelligence is still higher than the mind; and the soul is even higher than the intelligence.',
    textGu: 'ઇન્દ્રિયો શરીર કરતાં શ્રેષ્ઠ છે, મન ઇન્દ્રિયો કરતાં શ્રેષ્ઠ છે, બુદ્ધિ મન કરતાં ઉચ્ચ છે અને આત્મા બુદ્ધિ કરતાં પણ પર છે.',
    author: 'Bhagavad Gita 3.42',
  },

  {
    text: 'Whenever there is a decline in righteousness and an increase in unrighteousness, O Arjuna, at that time I manifest Myself.',
    textGu: 'હે અર્જુન, જ્યારે જ્યારે ધર્મની હાનિ અને અધર્મની વૃદ્ધિ થાય છે, ત્યારે ત્યારે હું સ્વયં પ્રગટ થાઉં છું.',
    author: 'Bhagavad Gita 4.7',
  },

  {
    text: 'To protect the righteous, to annihilate the wicked, and to reestablish the principles of dharma, I appear millennium after millennium.',
    textGu: 'સાધુજનોના રક્ષણ માટે, દુષ્ટોના વિનાશ માટે અને ધર્મની પુનઃસ્થાપના માટે હું યુગે યુગે પ્રગટ થાઉં છું.',
    author: 'Bhagavad Gita 4.8',
  },

  {
    text: 'In this world, aspirants may find enlightenment by two different paths: the path of knowledge for contemplative people, and the path of works for active people.',
    textGu: 'આ જગતમાં મેં બે નિષ્ઠાઓનો ઉપદેશ આપ્યો છે — જ્ઞાનમાર્ગ જ્ઞાનયોગીઓ માટે અને કર્મમાર્ગ કર્મયોગીઓ માટે.',
    author: 'Bhagavad Gita 3.3',
  },

  {
    text: 'The wise see with equal vision a learned brahmana, a cow, an elephant, a dog, and a dog-eater.',
    textGu: 'જ્ઞાની પુરુષ વિદ્વાન બ્રાહ્મણ, ગાય, હાથી, કૂતરો અને ચાંડાળ — સૌને સમદૃષ્ટિથી જુએ છે.',
    author: 'Bhagavad Gita 5.18',
  },

  {
    text: 'For one who has conquered the mind, the mind is the best of friends; but for one who has failed, the mind will remain the greatest enemy.',
    textGu: 'જેણે મનને જીતી લીધું છે, તેના માટે મન શ્રેષ્ઠ મિત્ર છે; પરંતુ જે મનને જીતી શક્યો નથી, તેના માટે મન સૌથી મોટો શત્રુ બની રહે છે.',
    author: 'Bhagavad Gita 6.6',
  },

  {
    text: 'Little by little, through patience and repeated effort, the mind will become stilled in the Self.',
    textGu: 'ધીરે ધીરે, ધૈર્ય અને સતત અભ્યાસ દ્વારા મનને આત્મામાં સ્થિર કરવું જોઈએ.',
    author: 'Bhagavad Gita 6.25',
  },

  {
    text: 'A true yogi observes Me in all beings and also sees every being in Me.',
    textGu: 'સાચો યોગી સર્વ પ્રાણીઓમાં મને જુએ છે અને સર્વ પ્રાણીઓને મારામાં જુએ છે.',
    author: 'Bhagavad Gita 6.29',
  },

  {
    text: 'One who sees Me everywhere and sees everything in Me is never lost to Me, nor am I ever lost to him.',
    textGu: 'જે મને સર્વત્ર જુએ છે અને સર્વને મારામાં જુએ છે, તે મારા માટે ક્યારેય અદૃશ્ય થતો નથી અને હું પણ તેના માટે ક્યારેય અદૃશ્ય થતો નથી.',
    author: 'Bhagavad Gita 6.30',
  },

  {
    text: 'Among thousands of men, one may endeavor for perfection, and of those who have achieved perfection, hardly one knows Me in truth.',
    textGu: 'હજારો મનુષ્યોમાં કોઈ એક સિદ્ધિ માટે પ્રયત્ન કરે છે, અને એવા સિદ્ધોમાં પણ કોઈ એક મને તત્ત્વથી ઓળખે છે.',
    author: 'Bhagavad Gita 7.3',
  },

  {
    text: 'I am the taste of water, the light of the sun and the moon, the syllable Om in the Vedic mantras; I am the sound in ether and ability in man.',
    textGu: 'હું જળમાં રહેલો રસ છું, સૂર્ય અને ચંદ્રનો પ્રકાશ છું, વૈદિક મંત્રોમાં પવિત્ર ઓમકાર છું, આકાશમાં રહેલો શબ્દ છું અને મનુષ્યોમાં રહેલી શક્તિ છું.',
    author: 'Bhagavad Gita 7.8',
  },

  {
    text: 'Whatever you do, whatever you eat, whatever you offer or give away, and whatever austerities you perform — do that as an offering to Me.',
    textGu: 'તું જે કંઈ કરે છે, જે કંઈ ખાય છે, જે કંઈ અર્પણ કરે છે, જે કંઈ દાન આપે છે અને જે તપ કરે છે — તે બધું મને અર્પણ કર.',
    author: 'Bhagavad Gita 9.27',
  },

  {
    text: 'Those who worship Me with devotion, meditating on My transcendental form — to them I carry what they lack and preserve what they have.',
    textGu: 'જે ભક્તો અનન્ય ભક્તિથી મારી ઉપાસના કરે છે અને મારું ચિંતન કરે છે, તેમના યોગક્ષેમનું વહન હું પોતે કરું છું.',
    author: 'Bhagavad Gita 9.22',
  },

  {
    text: 'Fix your mind on Me, be devoted to Me, worship Me, and offer reverence to Me. Thus you will come to Me without fail.',
    textGu: 'મારામાં મન પરોવ, મારો ભક્ત બન, મારી ઉપાસના કર અને મને નમસ્કાર કર. આમ, તું નિશ્ચિતપણે મને પ્રાપ્ત કરીશ.',
    author: 'Bhagavad Gita 9.34',
  },

  {
    text: 'I am the source of all spiritual and material worlds. Everything emanates from Me.',
    textGu: 'હું સમગ્ર આધ્યાત્મિક અને ભૌતિક જગતનો મૂળ સ્ત્રોત છું. સઘળું મારામાંથી જ પ્રગટ થાય છે.',
    author: 'Bhagavad Gita 10.8',
  },

  {
    text: 'I am the Self, O Gudakesha, seated in the hearts of all creatures. I am the beginning, the middle and the end of all beings.',
    textGu: 'હે ગુડાકેશ, હું સર્વ પ્રાણીઓના હૃદયમાં રહેલો આત્મા છું. હું સર્વ પ્રાણીઓનો આદિ, મધ્ય અને અંત છું.',
    author: 'Bhagavad Gita 10.20',
  },

  {
    text: 'If you become conscious of Me, you will pass over all the obstacles of conditioned life by My grace.',
    textGu: 'જો તું મારામાં ચિત્ત પરોવશે, તો મારી કૃપાથી જીવનના તમામ અવરોધોને પાર કરી શકીશ.',
    author: 'Bhagavad Gita 18.58',
  },

  {
    text: 'Abandon all varieties of dharma and just surrender unto Me. I shall deliver you from all sinful reactions. Do not fear.',
    textGu: 'સર્વ પ્રકારના ધર્મનો ત્યાગ કરીને માત્ર મારા શરણે આવ. હું તને સર્વ પાપોથી મુક્ત કરીશ. તું ભય ન રાખ.',
    author: 'Bhagavad Gita 18.66',
  },

  {
    text: 'A person is made of faith. Whatever one’s faith is, that person becomes.',
    textGu: 'મનુષ્યની શ્રદ્ધા જેવી હોય છે, તેવો જ તે બને છે. જેની જેવી શ્રદ્ધા હોય છે, તેનું વ્યક્તિત્વ પણ તેવું જ બને છે.',
    author: 'Bhagavad Gita 17.3',
  },

  {
    text: 'One who neither hates nor desires the fruits of his activities is known to be always renounced. Such a person, liberated from all dualities, easily overcomes material bondage.',
    textGu: 'જે ન કોઈનો દ્વેષ કરે છે અને ન તો કર્મફળની ઇચ્છા રાખે છે, તે સદૈવ સંન્યાસી કહેવાય છે. દ્વંદ્વોથી મુક્ત એવો મનુષ્ય સંસારના બંધનોમાંથી સરળતાથી મુક્ત થાય છે.',
    author: 'Bhagavad Gita 5.3',
  },

  {
    text: 'That which pervades the entire body you should know to be indestructible. No one is able to destroy that imperishable soul.',
    textGu: 'જે સમગ્ર શરીરમાં વ્યાપ્ત છે, તેને અવિનાશી જાણ. તે અવિનાશી આત્માનો નાશ કોઈ કરી શકતું નથી.',
    author: 'Bhagavad Gita 2.17',
  },

  {
    text: 'He who is free from attachment, who does not rejoice in success nor hate failure — such a one is firmly fixed in perfect knowledge.',
    textGu: 'જે આસક્તિથી મુક્ત છે, સફળતામાં હર્ષિત થતો નથી અને નિષ્ફળતાથી દ્વેષ કરતો નથી, તે સ્થિર પ્રજ્ઞાવાળો જ્ઞાની કહેવાય છે.',
    author: 'Bhagavad Gita 2.57',
  },
];

/** Random index — new quote on each page load / refresh. */
export function getTodaysMessageIndex(list = dailyMessages) {
  if (!list.length) return 0;

  return Math.floor(Math.random() * list.length);
}

/** Random Bhagavad Gita message — new on each call / page refresh. */
export function getTodaysMessage(list = dailyMessages) {
  const idx = getTodaysMessageIndex(list);

  return list[idx] || list[0] || { text: '', author: '' };
}